import { QUERY_KEY } from '@/const/key-stores';
import { useQState } from '@/hooks/useQState';

export const useReceptionInfo = () => {
  const [receptionNumber, setReceptionNumber] = useQState<string>(QUERY_KEY.receptionNumber);
  const [receptionName, setReceptionName] = useQState<string>(QUERY_KEY.receptionName);
  return { receptionNumber, setReceptionNumber, receptionName, setReceptionName };
};
